// Centralized environment variable handling
// This ensures environment variables are correctly typed and have fallbacks

export const ENV = {
  // Firebase Config
  FIREBASE_API_KEY: import.meta.env.VITE_FIREBASE_API_KEY as string || 'AIzaSyBc6VlEwx3XFqRbKY4VH7USMTnToGdIWoc',
  FIREBASE_AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string || 'invoice-software-8b984.firebaseapp.com',
  FIREBASE_PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID as string || 'invoice-software-8b984',
  FIREBASE_STORAGE_BUCKET: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET as string || 'invoice-software-8b984.firebasestorage.app',
  FIREBASE_MESSAGING_SENDER_ID: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID as string || '44102594753',
  FIREBASE_APP_ID: import.meta.env.VITE_FIREBASE_APP_ID as string || '1:44102594753:web:0ac7c904546ec805ba6440',
  FIREBASE_MEASUREMENT_ID: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID as string || 'G-Z8XBESMYKN',
  
  // NMI Payment Gateway
  NMI_API_URL: import.meta.env.VITE_NMI_API_URL as string || 'https://secure.networkmerchants.com/api/transact.php',
  NMI_COLLECT_JS_URL: import.meta.env.VITE_NMI_COLLECT_JS_URL as string || 'https://secure.networkmerchants.com/token/Collect.js',
  
  // API Configuration
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL as string || 'http://localhost:3013/api',
  API_ENDPOINT: import.meta.env.VITE_API_ENDPOINT as string || '/api/nmi/process',
  
  // Application URLs
  FRONTEND_URL: import.meta.env.VITE_FRONTEND_URL as string || 'http://localhost:3010',
  FRONTEND_PORT: Number(import.meta.env.VITE_FRONTEND_PORT || 3010),
  BACKEND_PORT: Number(import.meta.env.VITE_BACKEND_PORT || 3013),
  
  // Other
  SENDGRID_API_KEY: import.meta.env.VITE_SENDGRID_API_KEY as string || '',
  
  // Environment
  IS_DEVELOPMENT: import.meta.env.DEV === true,
  IS_PRODUCTION: import.meta.env.PROD === true,
  MODE: import.meta.env.MODE as string || 'development',
};

// For debugging
if (ENV.IS_DEVELOPMENT) {
  console.log('Environment Config:', ENV);
} 